// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1_employment_status.ml",
      62,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "EmploymentStatus"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Hrm"
              ]]
          },
          "Payroll"
        ]]
    });

const Payroll = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1_employment_status.ml",
      87,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "EmploymentStatus"
                    ]]
                },
                "V1"
              ]]
          },
          "Hrm"
        ]]
    });

const Hrm = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1_employment_status.ml",
      110,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "EmploymentStatus"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1_employment_status.ml",
      131,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "EmploymentStatus"
        ]]
    });

const EmploymentStatus = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1_employment_status.ml",
      150,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.hrm.v1.EmploymentStatus";
}

function to_int(param) {
  switch (param) {
    case /* EMPLOYMENT_STATUS_UNSPECIFIED */0 :
        return 0;
    case /* EMPLOYMENT_STATUS_ACTIVE */1 :
        return 10;
    case /* EMPLOYMENT_STATUS_TERMINATED */2 :
        return 20;
    
  }
}

function from_int_exn(n) {
  if (n !== 0) {
    if (n !== 10) {
      if (n !== 20) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* EMPLOYMENT_STATUS_TERMINATED */2;
      }
    } else {
      return /* EMPLOYMENT_STATUS_ACTIVE */1;
    }
  } else {
    return /* EMPLOYMENT_STATUS_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* EMPLOYMENT_STATUS_UNSPECIFIED */0 :
        return "EMPLOYMENT_STATUS_UNSPECIFIED";
    case /* EMPLOYMENT_STATUS_ACTIVE */1 :
        return "EMPLOYMENT_STATUS_ACTIVE";
    case /* EMPLOYMENT_STATUS_TERMINATED */2 :
        return "EMPLOYMENT_STATUS_TERMINATED";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "EMPLOYMENT_STATUS_ACTIVE" :
        return /* EMPLOYMENT_STATUS_ACTIVE */1;
    case "EMPLOYMENT_STATUS_TERMINATED" :
        return /* EMPLOYMENT_STATUS_TERMINATED */2;
    case "EMPLOYMENT_STATUS_UNSPECIFIED" :
        return /* EMPLOYMENT_STATUS_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, EmploymentStatus, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "EmploymentStatus"
        ]]
    }, V1, {
      EmploymentStatus: EmploymentStatus
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "EmploymentStatus"
              ]]
          },
          "V1"
        ]]
    }, Hrm, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "EmploymentStatus"
                    ]]
                },
                "V1"
              ]]
          },
          "Hrm"
        ]]
    }, Payroll, {
      Hrm: Hrm
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "EmploymentStatus"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Hrm"
              ]]
          },
          "Payroll"
        ]]
    }, Buhta, {
      Payroll: Payroll
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
